import './_vars.js';
import './_functions.js';
import './_components.js';

import { getHeaderHeight } from './functions/header-height.js';

getHeaderHeight();

// Burger menu

const asideMenu = document.querySelector('.main__aside');
const burger = document.querySelector('.header__burger');
const btnCloseMenu = document.querySelector('span.icon-icon-close');
const documentElementHTML = document.documentElement;

burger.addEventListener('click', () => {
  asideMenu.classList.add('transformation');
  documentElementHTML.classList.add('lock');
})

btnCloseMenu.addEventListener('click', () => {
  asideMenu.classList.remove('transformation');
  documentElementHTML.classList.remove('lock');
})

// Aside extend

if (document.querySelectorAll('.main__aside').length > 0) {
  const asideBtn = document.querySelector('.extender');
  const extenderBtnLeft = document.querySelector('.icon-icon-hevron-left');
  const extenderBtnRight = document.querySelector('.icon-icon-chevron-right');


  asideBtn.addEventListener('click', () => {
    asideMenu.classList.toggle('narrowed');
    extenderBtnLeft.classList.toggle('hidden');
    extenderBtnRight.classList.toggle('hidden');
  })
}




